var _taggedTemplateLiteral = require("C:/vagrant_tienda/apache/kinedu-educators-landing/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _defineProperty = require("C:/vagrant_tienda/apache/kinedu-educators-landing/node_modules/@babel/runtime/helpers/defineProperty");

var _objectWithoutProperties = require("C:/vagrant_tienda/apache/kinedu-educators-landing/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

module.exports = function (e) {
  var t = {};

  function n(r) {
    if (t[r]) return t[r].exports;
    var o = t[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
  }

  return n.m = e, n.c = t, n.d = function (e, t, r) {
    n.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: r
    });
  }, n.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, n.t = function (e, t) {
    if (1 & t && (e = n(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var r = Object.create(null);
    if (n.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var o in e) {
      n.d(r, o, function (t) {
        return e[t];
      }.bind(null, o));
    }
    return r;
  }, n.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return n.d(t, "a", t), t;
  }, n.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, n.p = "", n(n.s = 49);
}({
  1: function _(e, t) {
    e.exports = require("react");
  },
  2: function _(e, t) {
    e.exports = require("styled-components");
  },
  4: function _(e, t) {
    e.exports = require("../../utils/utils");
  },
  49: function _(e, t, n) {
    "use strict";

    var r = this && this.__importStar || function (e) {
      if (e && e.__esModule) return e;
      var t = {};
      if (null != e) for (var n in e) {
        Object.hasOwnProperty.call(e, n) && (t[n] = e[n]);
      }
      return t.default = e, t;
    },
        o = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var u = r(n(1)),
        a = r(n(2)),
        c = o(n(50)),
        i = n(4),
        l = u.default.createElement,
        s = u.default.forwardRef(function (_ref, n) {
      var e = _ref.children,
          t = _objectWithoutProperties(_ref, ["children"]);

      return l("span", _objectSpread({
        ref: n
      }, t), e);
    }),
        f = a.default(s)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n"])), function (_ref2) {
      var e = _ref2.theme;
      return e.wrapper;
    });

    t.default = function (e) {
      var _e$tag = e.tag,
          t = _e$tag === void 0 ? "span" : _e$tag,
          _e$disabled = e.disabled,
          n = _e$disabled === void 0 ? !1 : _e$disabled,
          _e$theme = e.theme,
          r = _e$theme === void 0 ? "Basic" : _e$theme,
          o = e.value,
          l = e.children,
          s = e.onChange,
          d = e.onPaste,
          p = _objectWithoutProperties(e, ["tag", "disabled", "theme", "value", "children", "onChange", "onPaste"]),
          m = u.useRef(document.createElement("span")),
          b = u.useRef(o);

      return u.useEffect(function () {
        m.current.innerHTML = o || "", b.current = o, function (e) {
          if (e) {
            var _t = document.createRange();

            _t.selectNodeContents(e), _t.collapse(!1);

            var _n = window.getSelection();

            _n && _n.removeAllRanges(), _n && _n.addRange(_t);
          }
        }(m.current);
      }, [o !== m.current.innerHTML]), u.default.createElement(a.ThemeProvider, {
        theme: i.isObject(r) ? r : c.default[r]
      }, u.default.createElement(f, Object.assign({
        className: "lego-editable",
        ref: m,
        tag: t,
        contentEditable: !n,
        suppressContentEditableWarning: !0,
        onInput: function onInput() {
          var e = m.current;
          if (!e) return;
          var t = e.innerHTML;
          b.current = t, s && s(t);
        },
        onPaste: function onPaste(e) {
          var t = e.clipboardData,
              n = t.getData("text"),
              r = window.getSelection();
          r.deleteFromDocument(), r.getRangeAt(0).insertNode(document.createTextNode(n)), e.preventDefault();

          var o = function (e) {
            e = (e = e.replace(/<br>/g, "$br$")).replace(/(?:\r\n|\r|\n)/g, "$br$");
            var t = document.createElement("div");
            return t.innerHTML = e, e = (e = t.textContent || t.innerText).replace(/\$br\$/g, "<br>");
          }(m.current.innerHTML);

          d && d(o);
        }
      }, p)));
    };
  },
  50: function _(e, t) {
    e.exports = require("../../themes/Editable.theme");
  }
});